import { render, staticRenderFns } from "./Chances.vue?vue&type=template&id=4922c840&scoped=true&"
import script from "./Chances.vue?vue&type=script&lang=js&"
export * from "./Chances.vue?vue&type=script&lang=js&"
import style0 from "./Chances.vue?vue&type=style&index=0&id=4922c840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922c840",
  null
  
)

export default component.exports